import { GetAuthContractPdfResponse } from 'api/laborerPortalAPI/authContract'
import { CallAPIAction, Status } from 'api/types'
import { GeneralFailResponse } from 'common/types/commonTypes'
import Actions from 'redux/actions'

type State = {
  url: string
} & Status

const initialState: State = {
  url: '',
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.GET_LABORER_AUTH_CONTRACT_PDF_ASYNC,
    Actions.GET_LABORER_AUTH_CONTRACT_PDF_SUCCESS,
    Actions.GET_LABORER_AUTH_CONTRACT_PDF_FAIL,
    GetAuthContractPdfResponse,
    GeneralFailResponse
  >,
): State => {
  switch (action.type) {
    case Actions.GET_LABORER_AUTH_CONTRACT_PDF_SUCCESS: {
      return {
        ...state,
        ...action.status,
        url: action.payload.url,
      }
    }
    case Actions.GET_LABORER_AUTH_CONTRACT_PDF_FAIL:
    case Actions.GET_LABORER_AUTH_CONTRACT_PDF_ASYNC: {
      return {
        ...state,
        ...action.status,
      }
    }
    default:
      return state
  }
}
